import React, { useCallback, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  InputAdornment,
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Pen from "../../../../assets/images/CourseManagement/pen.svg";
import { useStyles } from "./styles";

import useCourse from "../../../../Hooks/course";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import CustomPagination from "../../../../common/Pagination";
import usePagination from "../../../../common/usePagination";
import useAuthStore from "../../../../Hooks/auth";
import { useNavigate } from "react-router-dom";
import useHistorical from "../../../../Hooks/historical";

const studentColumns = [
  {
    id: "s.no",
    label: "S.No",
    align: "center",
    sortby: true,
    size: "small",
  },
  {
    id: "firstname",
    label: "Student Name",
    align: "center",
    sortby: true,
  },
  {
    id: "attendanceDate",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "forenoon",
    label: "Fore Noon",
    align: "center",
    sortby: true,
  },
  {
    id: "afternoon",
    label: "After Noon",
    align: "center",
    sortby: true,
  },
];
const studentAttendanceSchema = Yup.object().shape({
  toDate: Yup.date()
    .when("fromDate", (startDate, schema) => {
      console.log("startDate", startDate, schema);
      if (startDate) {
        const dayAfter = new Date(startDate.getTime());
        return schema.min(
          dayAfter,
          "* Date range looks incorrect"
          // "* The 'To' date cannot be earlier than the 'From' date. Please select a valid date range."
        );
      }
      return schema;
    })
    .required("* date is required")
    .nullable(),
  fromDate: Yup.date()
    .required("* date is required")
    .nullable(),
  regNumber: Yup.string().required("* Student ID is required"),
});

const Historical = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    attendanceData,
    attendancePagination,
    resetAttendanceAction,
    resetMarksAction,
    getHistoricalAttendanceAction,
  } = useHistorical();
  const formRef = React.useRef();

  const { getDepartmentAction } = useCourse();
  const [activeTab, setActiveTab] = useState("attendance2");
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  // const [regNo, setRegNo] = useState();
  // const [fromDateAttendance, setFromDateAttendance]= useState();
  // const [toDateAttendance, setTodateAttendance] = useState();
  const { institutionId } = useAuthStore();

  const handlePage = (e) => {
    setPerPage(e.target.value);
    setTimeout(() => {
      formRef?.current?.handleSubmit();
    }, 100);
  };

  React.useEffect(() => {
    resetAttendanceAction();
    resetMarksAction();
    return () => { };
  }, []);

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  const initStudentAttendance = {
    fromDate: "",
    toDate: "",
    regNumber: "",
    limit: "",
    offset: "",
  };

  console.log("attendanceData", attendanceData);
  const studentCount =
    attendanceData &&
    Math.ceil(attendancePagination?.totalNoOfRecords / PerPage);
  const _DATAStudent = usePagination(attendanceData, PerPage);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      // _DATA.jump(p);
    },
    [PerPage, page]
  );

  const handleChangeStudent = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      // _DATAStudent.jump(p);
      setTimeout(() => {
        formRef?.current?.handleSubmit();
      }, 100);
    },
    [PerPage, page]
  );
  console.log("studentCount", studentCount, page, PerPage);
  return (
    <Grid container className={classes.attendance}>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ flexDirection: "column" }}>
          <Stack
            sx={{
              flexDirection: "row",
              my: 2,
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          ></Stack>
        </Stack>
      </Grid>

      <Grid item lg={10} sm={12}>
        <Stack>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack sx={{ p: 4 }}>
                <Formik
                  initialValues={initStudentAttendance}
                  validationSchema={studentAttendanceSchema}
                  validateOnBlur={false}
                  validateOnChange={false}
                  enableReinitialize
                  innerRef={formRef}
                  onSubmit={(values) => {
                    getHistoricalAttendanceAction({
                      ...values,
                      limit: PerPage,
                      offset: offset,
                      institutionId,
                      historicalData: "Attendance",
                    });
                  }}
                >
                  {(formik) => {
                    const { errors, touched, handleChange, handleSubmit, values } =
                      formik;
                    return (
                      <form
                        onSubmit={handleSubmit}
                        className={classes.attendanceForm}
                      >
                        <Grid
                          container
                          sx={{ py: 1 }}
                          className={classes.form_add_course}
                          spacing={4}
                        >
                          <Grid item md={6} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Stack>
                                <Typography
                                  className={classes.textgap}
                                  sx={{ pr: 1 }}
                                >
                                  Student ID
                                </Typography>
                              </Stack>
                              <Stack>
                                <TextField
                                  sx={{
                                    width: "180px",
                                  }}
                                  id="regNumber"
                                  name="regNumber"
                                  placeholder={
                                    activeTab === "attendance1"
                                      ? "Search Student"
                                      : "Search Student"
                                  }
                                  type={"text"}
                                  className={
                                    errors.firstName && touched.firstName
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  value={values.regNumber}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{ cursor: "pointer" }}
                                      >
                                        <SearchIcon
                                          role="button"
                                          onClick={() => {
                                            formRef?.current?.handleSubmit();
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <ErrorMessage
                                  name="regNumber"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item md={6} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              gap={1}
                            >
                              <Stack>
                                <Typography
                                  className={classes.textgap}
                                  sx={{ pr: 5.5 }}
                                >
                                  Date From
                                </Typography>
                              </Stack>
                              <Stack>
                                <TextField
                                  id="fromDate"
                                  type="date"
                                  name="fromDate"
                                  sx={{
                                    width: "180px",
                                  }}
                                  value={values.fromDate}
                                  onChange={handleChange}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  placeholder="Enter Date From"
                                />
                                <ErrorMessage
                                  name="fromDate"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>

                        </Grid>
                        <Grid
                          container
                          sx={{ py: 1 }}
                          className={classes.form_add_course}
                          spacing={4}
                        >
                          <Grid item md={6} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Stack>
                                <Typography className={classes.textgap}>
                                  Date To
                                </Typography>
                              </Stack>
                              <Stack>
                                <TextField
                                  id="toDate"
                                  type="date"
                                  name="toDate"
                                  sx={{
                                    width: "180px",
                                  }}
                                  value={values.toDate}
                                  onChange={handleChange}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  placeholder="Enter Date To"
                                />
                                <ErrorMessage
                                  name="toDate"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>

                          <Grid item md={6}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                }}
                                gap={2}
                              >
                                <Button
                                  type="submit"
                                  sx={{
                                    px: 4,
                                    py: 1,
                                    borderRadius: "50px",
                                    minWidth: "150px",
                                  }}
                                  className={classes.search_btn}
                                >
                                  Search
                                </Button>
                              </Stack>
                            </Stack>
                          </Grid>
                        </Grid>
                      </form>
                    );
                  }}
                </Formik>
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </Grid>


















      <Grid item lg={10} sm={12}>
        <Stack sx={{ my: 4 }}>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack
                sx={{
                  padding: "12px 32px",
                }}
              >
                <TableContainer sx={{ maxHeight: "440px" }}>
                  <Table
                    aria-label="sticky table"
                    className={classes.root}
                    style={{ padding: 0 }}
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow classes={{ root: classes.thead }}>
                        {/* {activeTab === "attendance1" ? (
                          <>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </>
                        ) : (
                          <>
                            {studentColumns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </>
                        )} */}
                        <>
                          {studentColumns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </>
                      </TableRow>
                    </TableHead>

                    <TableBody classes={{ root: classes.tBody }}>
                      {/* {activeTab === "attendance1" ? (
                        <>
                          {staffAttendance && staffAttendance?.length > 0 ? (
                            _DATA.currentData()?.map((_el, index) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                {columns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "s.no" ? (
                                        <span>{index + 1}</span>
                                      ) : column.id === "name" ? (
                                        _el.name
                                      ) : column.id === "attendanceDate" ? (
                                        _el.attendanceDate
                                      ) : column.id === "forenoon" ? (
                                        Boolean(Number(_el.forenoon)) == "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "afternoon" ? (
                                        Boolean(Number(_el.afternoon)) ==
                                        "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={columns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      ) : (
                        <>
                          {studentAttendance &&
                          studentAttendance?.studentAttendance?.length > 0 ? (
                            _DATAStudent.currentData()?.map((_el, index) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                {studentColumns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "s.no" ? (
                                        <span>{index + 1}</span>
                                      ) : column.id === "firstname" ? (
                                        _el.firstname
                                      ) : column.id === "attendanceDate" ? (
                                        _el.attendanceDate
                                      ) : column.id === "forenoon" ? (
                                        Boolean(Number(_el.forenoon)) == "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "afternoon" ? (
                                        Boolean(Number(_el.afternoon)) ==
                                        "1" ? (
                                          "Present"
                                        ) : (
                                          "Absent"
                                        )
                                      ) : column.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          // onClick={editList}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={studentColumns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )} */}
                      <>
                        {attendanceData && attendanceData.length > 0 ? (
                          _DATAStudent.currentData()?.map((_el, index) => (
                            <TableRow role="checkbox" tabIndex={-1} key={index}>
                              {studentColumns.map((column) => {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    lineHeight={0}
                                  >
                                    {column.id === "s.no" ? (
                                      <span>{offset + index + 1}</span>
                                    ) : column.id === "firstname" ? (
                                      _el.firstname
                                    ) : column.id === "attendanceDate" ? (
                                      _el.attendanceDate
                                    ) : column.id === "forenoon" ? (
                                      Boolean(Number(_el.forenoon)) == "1" ? (
                                        //   "Present"
                                        // ) : (
                                        //   "Absent"

                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "green",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Present
                                          </p>
                                          {/* <p style={{ color: "black" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      ) : (
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "red",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Absent
                                          </p>
                                          {/* <p style={{ color: "red" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      )
                                    ) : column.id === "afternoon" ? (
                                      Boolean(Number(_el.afternoon)) == "1" ? (
                                        //   "Present"
                                        // ) : (
                                        //   "Absent"
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "green",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Present
                                          </p>
                                          {/* <p style={{ color: "black" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      ) : (
                                        <Grid
                                          display="flex"
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          {" "}
                                          <p
                                            style={{
                                              color: "red",
                                              paddingRight: "20px",
                                            }}
                                          >
                                            Absent
                                          </p>
                                          {/* <p style={{ color: "red" }}>
                                          Absent
                                        </p> */}{" "}
                                        </Grid>
                                      )
                                    ) : column.id === "edit" ? (
                                      <Stack
                                        sx={{
                                          alignItems: "center",
                                          cursor: "pointer",
                                        }}
                                      // onClick={editList}
                                      >
                                        <img src={Pen} alt="pen" />
                                      </Stack>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={studentColumns.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data Available
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    </TableBody>
                  </Table>
                </TableContainer>
                {/* {staffAttendance?.length > 0 && activeTab === "attendance1" && (
                  <CustomPagination
                    count={count}
                    page={page}
                    onPageChange={handleChange}
                    handlePage={handlePage}
                    perPage={PerPage}
                  />
                )} */}
                {attendancePagination?.totalNoOfRecords > 10 && activeTab === "attendance2" && (
                  <CustomPagination
                    count={studentCount}
                    page={page}
                    onPageChange={handleChangeStudent}
                    handlePage={handlePage}
                    perPage={PerPage}
                  />
                )}
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Historical;
